// extracted by mini-css-extract-plugin
module.exports = {"LoginSignup":"LoginSignup_LoginSignup__5MZwt","isDesktopOnly":"LoginSignup_isDesktopOnly__aHGa7","active":"LoginSignup_active__qokYs","Pipe":"LoginSignup_Pipe__FXFdr"};